
import React, { useEffect, useState } from 'react'
import CustomBtn from "../CustomBtn/CustomBtn";
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import CustomInput from '../CustomInput/CustomInput';
import Select from 'react-select';
import "./AddClassForm.css"
import { useNavigate } from 'react-router-dom';
function AddClassForm() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();

  const [loading, setLoading] = useState('')
  const [name, setName] = useState('')
  const [grade_id, setSelectedGradeId] = useState(""); // State to store selected ID
  const [max_students, setMax_students] = useState('')
  const [session_number, setSession_number] = useState('')
  const [gradeItems, setGradeItems] = useState([])
  useEffect(() => {
    const getAllApis = async () => {


      await axios
      .get(`https://nanosoft.space/taarteb/public/api/grades`, {
          headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
      })
      .then(async (res) => {
        const groupedData = res.data.data.data.reduce((acc, item) => {
          const category = item.category;
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push({ label: item.name, value: item.id }); 
          return acc;
        }, {});
        
        // Convert grouped data into react-select format
        const selectOptions = Object.keys(groupedData).map(category => ({
          label: category, // Category name
          options: groupedData[category] // Array of options within that category
        }));
        
        setGradeItems(selectOptions); // Assuming setGradeItems is your state setter

      })
      .catch((error) => {



      });

    }
    getAllApis()

  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    

      setLoading(true);


      try {
        const response = await axios.post('https://nanosoft.space/taarteb/public/api/classes', {
          name,
          grade_id:grade_id.value,
          max_students,
          session_number,
  
        }, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        });
        navigate('/dashboard/classes')  
  
      } catch (error) {
        console.error("Error:", error.response?.data || error.message);
        toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

        
      } finally {
        setLoading(false);
      }


  };


  return (
    <div className='add_class_form_container'>
      <ToastContainer />

      <form className='form_container'>
        <Container fluid>
          <Row>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.namePlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.namePlaceholder}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </Col>
 

            <Col md={6}>
              <div>
                <label>{currentLocal.home.grade}</label>
                <br />

                <Select
        value={grade_id}
        onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
        options={gradeItems}
        placeholder={currentLocal.home.SelectGrades} // Change this text

      />
 
              </div>
            </Col>

            <Col md={6}className='mt-3'>
              <div>
                <label>{currentLocal.home.MaxStudents}</label>
                <CustomInput
                  placeholder={currentLocal.home.MaxStudents}
                  value={max_students}
                  onChange={(e) => setMax_students(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}className='mt-3'>
              <div>
                <label> {currentLocal.home.sessionnumber}</label>
                <CustomInput
                  placeholder={currentLocal.home.sessionnumber}
                  value={session_number}
                  onChange={(e) => setSession_number(e.target.value)}
                />
              </div>
            </Col>

            <Col md={12}>
              <div className=' mt-4 '>
                <div className='w-50'>



                </div>
              </div>
            </Col>
            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading: currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  )
}

export default AddClassForm
